//import store from '@/store'
import env from 'env'
import moment from 'moment'
import { MARUNAGE_TABLE } from '@/plugins/handsontable'

const getters = {
    env: state => env,
    data: (state) => {
        if (state.app.data) {
            return state.app.data
        } else {
            return {
            }
        }
    },
    config: (state) => {
        if (state.app.data) {
            return state.app.data.config
        } else {
            return {
            }
        }
    },
    trans: (state) => {
        if (state.app.data) {
            return state.app.data.trans
        } else {
            return {
                labels: [],
                models: [],
                pages: [],
            }
        }
    },
    insurance_fillable_auto: (state) => {
        if (state.app.data) {
            return state.app.data.insurance_fillable_auto
        } else {
            return []
        }
    },
    user_fillable_profile_for_user: (state) => {
        if (state.app.data) {
            return state.app.data.user_fillable_profile_for_user
        } else {
            return []
        }
    },
    route_auth_level(state) {
        return app => {
            return app.$router.currentRoute.meta.auth_level
        }
    },
    route_navbar(state) {
        return app => {
            return app.$router.currentRoute.meta.navbar
        }
    },
    csrf_token(state) {
        return document.getElementsByName('csrf-token')[0].content
    },
//    route_auth_level: state => this.$router.currentRoute.meta.auth_level,
    auth_user: state => state.auth.user,
    auth_check: state => !! state.auth.user,
    auth_token: state => {
        return state.auth.user ? state.auth.user.token : null
    },
    auth_email: state => state.auth.user ? state.auth.user.email : '',
    auth_name: state => state.auth.user ? state.auth.user.name.trim() : '',
    auth_profile: state => state.auth.user ? state.auth.user.profile || [] : [],
    auth_pages: state => state.auth.user ? state.auth.user.pages || [] : [],
    auth_batches: state => state.auth.user ? state.auth.user.batches || {} : {},
    auth_group: state => state.auth.user ? state.auth.user.group || [] : [],
    auth_level: state => state.auth.user ? state.auth.user.level : '000',
    auth_level_name: state => {
        if (!state.auth.user) {
            return '000'
        }
        switch (state.auth.user.level) {
            case '000':
                return 'None'
            case '100':
                return 'User'
            case '200':
                return 'Admin'
            default:
                return 'None'
        }
    },
    auth_functions: state => state.auth.user ? state.auth.user.functions : {},
    auth_id: state => state.auth.user ? state.auth.user.id : null,
    auth_uuid: state => state.auth.user ? state.auth.user.uuid : '',
    notification_queue: state => state.notification.queue,
    axios_queue: state => state.axios.queue,
    axios_queue_length: state => Object.keys(state.axios.queue).length,
    filter4address(state) {
        return (item, type) => {
            switch (item.provider_type) {
                case 'tuskey':
                    return item
                case 'ebay':
                    return {
                        representative: item.address.Name,
                        company: null,
                        line1: item.address.Street1,
                        line2: item.address.Street2,
                        city: item.address.CityName,
                        state: item.address.StateOrProvince,
                        zip: item.address.PostalCode,
                        country: item.address.CountryName,
                        email: item.buyer_email,
                        tel: item.address.Phone === 'Invalid Request' ? null : item.address.Phone,
                    }
            }
            return item
        }
    },
    shipping_address_default(state) {
        const _default = {
            type: 'from',
            is_default: 0,
            tax_id: {},
        }

        return (type) => {
            if (!type) {
                return _default
            }
            _default.type = type

            if (!state.app.data) {
                return _default
            }

            let shipping_addresses = state.app.data.shipping_addresses || []
            for (let i = 0; i < shipping_addresses.length; i++) {
                if (shipping_addresses[i].type !== type) {
                    continue
                }
                if (!shipping_addresses[i].is_default) {
                    continue
                }
                return shipping_addresses[i]
            }

            return _default
        }
    },
    shipping_item_default(state) {
        let shipping_items = state.app.data.shipping_items || []
        for (let i = 0; i < shipping_items.length; i++) {
            if (!shipping_items[i].is_default) {
                continue
            }
            return shipping_items[i]
        }
        return null
    },
    shipping_box_default(state) {
        let shipping_boxes = state.app.data.shipping_boxes || []
        for (let i = 0; i < shipping_boxes.length; i++) {
            if (!shipping_boxes[i].is_default) {
                continue
            }
            return shipping_boxes[i]
        }
        return null
    },
    ////////////////////////////////////////////
    marunage_default(state) {
//        let shipping_address_default_from = getters.shipping_address_default(state)('from')
//        let shipping_address_default_to = getters.shipping_address_default(state)('to')
//        let shipping_item_default = getters.shipping_item_default(state)
        let insurance = getters.create_insurance(state)({
//            from: shipping_address_default_from,
//            to: shipping_address_default_to,
//            shipping_item: shipping_item_default,
        })
        insurance.user_id = getters.auth_id(state)
        return insurance
    },
    create_marunage(state) {
        return (options) => {
            let data = {}
            MARUNAGE_TABLE().FIELDS_ALL.forEach((v, i) => {
                data[v.name] = null;
            })
//            if (options.hasOwnProperty('from')) {
//                if (options.from === null || typeof options.from !== 'object') {
//                    options.from = {}
//                }
//                [
//                    'representative',
//                    'company',
//                    'email',
//                    'tel',
//                ].forEach((v) => {
//                    if (typeof options.from[v] === 'undefined') {
//                        options.from[v] = null
//                    }
//                    data['from_' + v] = options.from[v]
//                })
//                data.from_address = [
//                    options.from.line1,
//                    options.from.line2,
//                    options.from.city,
//                    options.from.state,
//                    options.from.zip,
//                    options.from.country,
//                    ].filter((v) => {
//                        return v
//                    }).join(', ')
//            }
//            if (options.hasOwnProperty('to')) {
//                if (options.to === null || typeof options.to !== 'object') {
//                    options.to = {}
//                }
//                [
//                    'representative',
//                    'company',
//                    'line1',
//                    'line2',
//                    'city',
//                    'state',
//                    'zip',
//                    'country',
//                    'email',
//                    'tel',
//                ].forEach((v) => {
//                    if (typeof options.to[v] === 'undefined') {
//                        options.to[v] = null
//                    }
//                    data['to_' + v] = options.to[v]
//                })
//            }
//            if (options.hasOwnProperty('shipping_item')) {
//                if (options.shipping_item === null || typeof options.shipping_item !== 'object') {
//                    options.shipping_item = {}
//                }
//                [
//                    'hs_code',
//                    'country',
//                ].forEach((v) => {
//                    if (typeof options.shipping_item[v] === 'undefined') {
//                        options.shipping_item[v] = null
//                    }
//                    data['shipping_item_' + v] = options.shipping_item[v]
//                })
//                data.shipping_item_name = options.shipping_item.product
//                data.shipping_item_currency = options.shipping_item.currency || 'JPY'
//                data.shipping_item_price = (options.shipping_item.price || '') + ''
//                data.shipping_item_quantity = (options.shipping_item.quantity || 1) + ''
//            }
            delete data.id
            delete data.updated_at
            return data
        }
    },
    ////////////////////////////////////////////
    insurance_default(state) {
        let shipping_address_default_from = getters.shipping_address_default(state)('from')
        let shipping_address_default_to = getters.shipping_address_default(state)('to')
        let shipping_item_default = getters.shipping_item_default(state)
        let insurance = getters.create_insurance(state)({
            from: shipping_address_default_from,
            to: shipping_address_default_to,
            shipping_item: shipping_item_default,
        })
        insurance.user_id = getters.auth_id(state)
        return insurance
    },
    create_insurance(state) {
        return (options) => {
            let data = {}
            if (options.hasOwnProperty('from')) {
                if (options.from === null || typeof options.from !== 'object') {
                    options.from = {}
                }
                [
                    'representative',
                    'company',
                    'email',
                    'tel',
                ].forEach((v) => {
                    if (typeof options.from[v] === 'undefined') {
                        options.from[v] = null
                    }
                    data['from_' + v] = options.from[v]
                })
                data.from_address = [
                    options.from.line1,
                    options.from.line2,
                    options.from.city,
                    options.from.state,
                    options.from.zip,
                    options.from.country,
                    ].filter((v) => {
                        return v
                    }).join(', ')
            }
            if (options.hasOwnProperty('to')) {
                if (options.to === null || typeof options.to !== 'object') {
                    options.to = {}
                }
                [
                    'representative',
                    'company',
                    'line1',
                    'line2',
                    'city',
                    'state',
                    'zip',
                    'country',
                    'email',
                    'tel',
                ].forEach((v) => {
                    if (typeof options.to[v] === 'undefined') {
                        options.to[v] = null
                    }
                    data['to_' + v] = options.to[v]
                })
            }
            if (options.hasOwnProperty('shipping_item')) {
                if (options.shipping_item === null || typeof options.shipping_item !== 'object') {
                    options.shipping_item = {}
                }
                [
                    'hs_code',
                    'country',
                ].forEach((v) => {
                    if (typeof options.shipping_item[v] === 'undefined') {
                        options.shipping_item[v] = null
                    }
                    data['shipping_item_' + v] = options.shipping_item[v]
                })
                data.shipping_item_name = options.shipping_item.product
                data.shipping_item_currency = options.shipping_item.currency || 'JPY'
                data.shipping_item_price = (options.shipping_item.price || '') + ''
                data.shipping_item_quantity = (options.shipping_item.quantity || 1) + ''
            }
            delete data.id
            delete data.updated_at
            return data
        }
    },
    shipping_default(state) {
        let shipping_address_default_from = getters.shipping_address_default(state)('from')
        let shipping_address_default_to = getters.shipping_address_default(state)('to')
        let shipping_address_default_importer = getters.shipping_address_default(state)('importer')
        let shipping_item_default = getters.shipping_item_default(state)
        let shipping_box_default = getters.shipping_box_default(state)
console.log(JSON.stringify(shipping_address_default_to))
        let shipping = getters.create_shipping(state)({
            from: shipping_address_default_from,
            to: shipping_address_default_to,
            importer: shipping_address_default_importer,
            shipping_item: shipping_item_default,
            shipping_box: shipping_box_default,
        })

        // other
console.log(shipping_item_default)
        const today = new moment
        const tomorrow = (new moment).add(1, 'days')
        return Object.assign(
            shipping,
            {
                data_orders_selected: [],
                item_currency: shipping_item_default ? shipping_item_default.currency : 'JPY',
                box_description: '',

                insurance: false,
//                vat: {
//                    shipping_tax_target: null,
//                    shipping_tax_name: '',
//                    shipping_tax_vat: '',
//                },
//                invoice: {
//                    number: null,
//                    issued_at: today.format('YYYY-MM-DD'),
//                    signature: '',
//                },
                courier: {
                    shipping_date: today.format('YYYY-MM-DD'),
                    plt: true,
                    shipping_courier_plan: {
                        courier: null,
                        plan_name: null,
                        plan_value: null,
                        options: {
                            // DHL
                            dhl_invoice: {
                                number: null,
                                issued_at: today.format('YYYY-MM-DD'),
                                signature: '',
                            },
                            dhl_vat: {
                                shipping_tax_target: null,
                                shipping_tax_name: '',
                                shipping_tax_vat: '',
                            },

                            // ECMS
                            ecms_incoterms: 'DAP',
                            ecms_prefered_export_declaration_entry: null,
                            ecms_duties_paid_by: null,
                            ecms_export_reason: 'commercial',
                            ecms_pickup_courier: null,
                            ecms_pickup_waybill_number: null,
                        },
                    },
                },
            }
        )
    },
    trim_address(state) {
        return (model, type) => {
            let data = {}
            Object.keys(model).forEach((key) => {
                if (key.indexOf(type + '_') === 0) {
                    data[key] = model[key]
                }
            })
            return data
        }
    },
    create_shipping(state) {
        return (options) => {
            let data = {}
            if (options.hasOwnProperty('from')) {
                if (options.from === null || typeof options.from !== 'object') {
                    options.from = {}
                }
                [
                    'representative',
                    'company',
                    'line1',
                    'line2',
                    'city',
                    'state',
                    'zip',
                    'country',
                    'email',
                    'tel',
                    'tax_id',
                ].forEach((v) => {
                    if (options.from[v] === 'undefined' || options.from[v] === null) {
                        if (v === 'tax_id') {
                            options.from[v] = {}
                            this.data(state).tax_id_types.forEach((tax_id_type) => {
                                options.from[v][tax_id_type] = ''
                            })
                        } else {
                             options.from[v] = null
                        }
                    }
                    data['from_' + v] = options.from[v]
                })
            }
            if (options.hasOwnProperty('to')) {
                if (options.to === null || typeof options.to !== 'object') {
                    options.to = {}
                }
                [
                    'representative',
                    'company',
                    'line1',
                    'line2',
                    'city',
                    'state',
                    'zip',
                    'country',
                    'email',
                    'tel',
                    'tax_id',
                ].forEach((v) => {
                    if (options.to[v] === 'undefined' || options.to[v] === null) {
                        if (v === 'tax_id') {
                            options.to[v] = {}
                            this.data(state).tax_id_types.forEach((tax_id_type) => {
                                options.to[v][tax_id_type] = ''
                            })
                        } else {
                             options.to[v] = null
                        }
                    }
                    data['to_' + v] = options.to[v]
                })
            }
            if (options.hasOwnProperty('importer')) {
                if (options.importer === null || typeof options.importer !== 'object') {
                    options.importer = {}
                }
                [
                    'representative',
                    'company',
                    'line1',
                    'line2',
                    'city',
                    'state',
                    'zip',
                    'country',
                    'email',
                    'tel',
                    'tax_id',
                ].forEach((v) => {
                    if (options.importer[v] === 'undefined' || options.importer[v] === null) {
                        if (v === 'tax_id') {
                            options.importer[v] = {}
                            this.data(state).tax_id_types.forEach((tax_id_type) => {
                                options.importer[v][tax_id_type] = ''
                            })
                        } else {
                             options.importer[v] = null
                        }
                    }
                    data['importer_' + v] = options.importer[v]
                })
            }
            if (options.hasOwnProperty('shipping_item')) {
                data.items = [{}]

                if (options.shipping_item === null || typeof options.shipping_item !== 'object') {
                    options.shipping_item = {}
                }

                [
                    'quantity',
                    'hs_code',
                    'country',
                    'product',
                    'weight_net',
                    'weight_gross',
                    'price',
                ].forEach((v) => {
                    if (typeof options.shipping_item[v] === 'undefined') {
                        options.shipping_item[v] = null
                    }
                    data.items[0][v] = options.shipping_item[v]
                })
            }
            if (options.hasOwnProperty('shipping_box')) {
                data.boxes = [{}]

                if (options.shipping_box === null || typeof options.shipping_box !== 'object') {
                    options.shipping_box = {}
                }
                [
                    'depth',
                    'width',
                    'height',
                    'weight',
                ].forEach((v) => {
                    if (typeof options.shipping_box[v] === 'undefined') {
                        options.shipping_box[v] = null
                    }
                    data.boxes[0][v] = options.shipping_box[v]
                })
            }
            delete data.id
            delete data.updated_at
            return data
        }
    },
    dimensional_weight(state) {
        return (depth, width, height) => {
            let dimensional_weight = parseFloat(depth) * parseFloat(width) * parseFloat(height) / 5000.0
            return Math.ceil(2 * dimensional_weight) / 2 || null
        }
    },
    get_item_subtotal(state, getters) {
        return (item, type) => {
            let subtotal = Number.parseInt(item.quantity || 1) * getters.get_casted_price(item.price, type)
            return subtotal || 0
        }
    },
    get_items_total(state, getters) {
        return (items, type) => {
            let data = {
                total_item_price: 0,
                total_item_count: 0,
            }
            if (!items) {
                return data
            }
            for (let i = 0; i < items.length; i++) {
                let subtotal = getters.get_item_subtotal(items[i], type)
                //if (!model.items[i].country || !model.items[i].product || !model.items[i].price) {
                //    continue
                //}
                data.total_item_price += (getters.get_casted_price(subtotal, type) || 0)
                data.total_item_count += (Number.parseInt(items[i].quantity) || 1)
            }
            data.total_item_price = Number(data.total_item_price.toFixed(3))
//            data.total_item_price = Number(data.total_item_price.toFixed(2))
            return data
        }
    },
    get_casted_price(state, getters) {
        return (price, type) => {
            switch (type) {
                case 'int':
                    return Number.parseInt(price)
                default:
                    return Number.parseFloat(price)
            }
        }
    },
    get_boxes_total(state, getters) {
        return (items, type) => {
            let data = {
                total_weight: 0,
                total_dimensional_weight: 0,
            }
            if (!items) {
                return data
            }
            for (let i = 0; i < items.length; i++) {
                let dimensional_weight = getters.get_box_dimensinal_weight(items[i])
                data.total_weight += (Number.parseFloat(items[i].weight) || 0)
                data.total_dimensional_weight += dimensional_weight || 0
            }
            data.total_weight = Number(data.total_weight.toFixed(2))
            data.total_dimensional_weight = Number(data.total_dimensional_weight.toFixed(2))
            return data
        }
    },
    get_box_dimensinal_weight(state, getters) {
        return (item) => {
            let dimensional_weight = parseFloat(item.depth) * parseFloat(item.width) * parseFloat(item.height) / 5000.0
            return Math.ceil(2 * dimensional_weight) / 2 || null
        }
    },
}
export default getters


